import React from "react";
import { View, Text, StyleSheet, ViewStyle, TextStyle } from "react-native";
import { COLORS } from "@dehaat/dds";

type ProgressBarProps = {
  value?: number;
  height?: number;
  backgroundColor?: string;
  fillColor?: string;
  borderRadius?: number;
  showPercent?: boolean;
  style?: ViewStyle;
  trackStyle?: ViewStyle;
  progressStyle?: ViewStyle;
  percentTextStyle?: TextStyle;
};

const ProgressBar: React.FC<ProgressBarProps> = ({
  value = 0,
  height = 20,
  backgroundColor = COLORS.neutral40,
  fillColor = COLORS.primary100,
  borderRadius = 16,
  style = {},
  trackStyle = {},
  progressStyle = {},
  percentTextStyle = {},
}) => {
  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <View style={[styles.wrapper, { height }, style]}>
      <View
        style={[
          styles.track,
          {
            backgroundColor,
            borderRadius,
            height,
          },
          trackStyle,
        ]}
      >
        <View
          style={[
            styles.fill,
            {
              width: `${clampedValue}%`,
              backgroundColor: fillColor,
              borderRadius,
            },
            progressStyle,
          ]}
        >
          {" "}
          <Text
            style={[
              styles.centerRight,
              { lineHeight: height },
              percentTextStyle,
            ]}
          >
            {clampedValue}%
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width: "100%",
  },
  track: {
    width: "100%",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
  },
  fill: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
  },
  percentLabels: {
    position: "absolute",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 10,
    zIndex: 1,
  },

  centerRight: {
    marginLeft: "auto",
    color: "white",
    paddingRight: 10,
  },
});

export default ProgressBar;
